import React, { useEffect, useState } from "react";
import useProductDetail from "../Hooks/useProductDetail";
import Column from "antd/es/table/Column";
import ProductCard from "./ProductCard";
import OrderTracking from "./OrderTracking";
import useOrderStatuses from "../Hooks/useOrderStatuses";
import { format, getOverlappingDaysInIntervals } from 'date-fns';
import useCancelOrder from '../Hooks/useCancelOrder';
import { Toast } from "react-bootstrap";

import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const OrderDetails = ({order, close}) => {
    const { product} = useProductDetail(order.products[0]);
    const [imagesArray, setImagesArray] = useState(null);
    const {orderStatuses} = useOrderStatuses();
    const { cancelOrder, isLoading, error, success } = useCancelOrder();
    const [activeSection, setActiveSection] = useState("dashboard");
    const navigate = useNavigate();
    
    const handleOrderCancel = async (OID) =>{
        
        if (window.confirm("Are you sure you want to cancel the order")){
            const response = await cancelOrder(OID,"Cancel by User")
            toast.success("Order has been cancelled successfully");
            close();
        }
       
    }

    useEffect(() => {
        if (product && product.images && product.images.length > 0 && imagesArray?.length < product.images.length ) {
            var tempArr=[];
            product.images.map((item) =>  {
                tempArr.push(item.image)
            })
            
            setImagesArray(tempArr);
        }
      
      });
    return(

        <div style={styles.content}>
                    <div style={styles.section}>
                        <h3 style={styles.sectionHeader}>{order.first_name} {order.last_name}
                            <i className="fa-solid fa-envelope ml-2"></i> {order.email} <i className="fa-solid fa-phone ml-2"></i> {order.phone}
                        </h3>
                        <div style={styles.row}>
                           <div style={styles.Column}>
                           <div style={styles.labelValue}>
                                <span style={styles.label}>Order Number:</span>
                                <span style={styles.value}>{order.order_number}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>City:</span>
                                <span style={styles.value}>{order.city}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Date:</span>
                                <span style={styles.value}>
                                    {new Date(order.created_at).toLocaleString()}
                                </span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Status:</span>
                                <span style={styles.value}>{order.status.status}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Total:</span>
                                <span style={styles.value}>PKR {order.total}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Shipping Address:</span>
                                <span style={styles.value}>{order.address}, {order.city}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Shipping VIA:</span>
                                <span style={styles.value}>{order.shipping_method.replace('_',' ')}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Payment Method:</span>
                                <span style={styles.value}>{order.payment_method.replace('_',' ')}</span>
                            </div>
                            <div style={styles.labelValue}>
                                <span style={styles.label}>Billing Address:</span>
                                <span style={styles.value}>{order.billing_address_address}, {order.billing_city}</span>
                            </div>
                            {order.status.is_cancel}
                            {order.status.is_cancel && (
                                <button
                                   onClick={() =>{handleOrderCancel(order.order_number)}}
                                
                                    className="bg-red-700 w-[95%] text-white font-semibold py-2 px-4 rounded disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    Cancel Order
                          </button>  

                            )}
                            
                           </div>

                           <div style={styles.imageColumn}>
                           
                               {product &&(
                                        <ProductCard
                                        id={product.id}
                                        key={product.id}
                                        height={390}
                                        
                                        name={product.name}
                                       
                                        image={[product.images[0]?.image,product.images[1]?.image]}
                                        addToBag={false}
                                        isImageArray={true}
                                        //navigateLink={`/product/${product.id}`}
                                        rating={product.average_rating? product.average_rating : ''}
                                    />           
                                )}
                           </div>
                        </div>
                    </div>

                    {order.status.status != "Cancelled"? (
                        <div style={styles.section}>
                        <h3 style={styles.sectionHeader}>Order Tracking</h3>
                        <OrderTracking statuses={orderStatuses} currentStatus={order.status.status}/>
                    </div>

                    ):(
                        <div style={styles.section}>
                        Order was cancelled by <strong>{order.updated_by}</strong> on <strong> {format(order.updated_at,'dd/MM/yyyy')}</strong>
                        
                    </div>
                    )}
                    
                </div>
    )
    
}

const styles = {
    content: {
        color: "#555",
    },
    section: {
        marginBottom: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
    },
    sectionHeader: {
        fontSize: "0.8em",
        marginBottom: "10px",
        color: "#333",
        borderBottom: "1px solid #ddd",
        paddingBottom: "5px",
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px",
    },
    Column:{
        flex:"1"
    },
    imageColumn: {
        flex: "0 0 270px",
        textAlign: "center",
    },
    labelValue: {
        flex: "0 0 48%",
        fontSize:'0.8em',
        marginBottom:'20px'
    },
    label: {
        fontWeight: "bold",
        // display: "block",
        marginBottom: "20px",
    },
    value: {
        color: "#555",
        marginLeft:'5px'
    },
}

export default OrderDetails;